<template>
  <form @submit.prevent="$emit('submit')">
    <slot></slot>
    <slot v-if="action" name="submit">
      <div class="p-4 flex w-full justify-end flex-col-reverse md:flex-row">
        <vue-button @click="$modal.close()" class="btn btn-gray btn-outline w-full md:w-auto md:mr-2">Fermer</vue-button>
        <vue-button type="submit" class="btn btn-primary w-full md:w-auto mb-2 md:mb-0" :status="status" :disabled="disabled">
          {{ action === 'update' ? 'Mettre à jour' : 'Ajouter' }}
        </vue-button>
      </div>
    </slot>
  </form>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
    status: {
      type: String,
      default: null,
    },
    action: {
      type: String,
      default: null,
    },
  },
};
</script>
